import { degen as viemDegen } from 'viem/chains';

import { defaultServices } from '../configHelpers';
import type { AllChainConfig } from '../configTypes';

export const degen = {
  displayName: 'Degen Chain',
  runtime: 'evm',
  viemChain: viemDegen,
  isSupported: false,
  isMainnet: true,
  services: defaultServices({
    zerion: { chainKey: 'degen' },
    pimlico: { chainSlug: 'degen' },
  }),
} as const satisfies AllChainConfig<'evm', false>;
